module.exports = __webpack_public_path__ + "img/bat.d29e0d7e.svg";